import { Form } from 'src/app/models/form.model';
import { UserService } from './../../services/user.service';
import { MatDialog, MatSidenav, MatIconRegistry, MatSnackBar } from '@angular/material';
import { Component, ViewChild, OnInit, TemplateRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BorradoresComponent } from '../borradores/borradores.component';
import { crearBorradorComponent } from '../borradores/crearBorrador/crearBorrador.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as FormActions from '../../reducers/actions/forms.actions';
import * as FinalFormactions from '../../reducers/actions/form_final.actions';
import { SidenavService } from 'src/app/services/sidenav.service';
import { SolicitudesExpComponent } from '../solicitudesexp/solicitudesexp.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { Notification } from 'src/app/models/notification.model';
import * as NotificationActions from '../../reducers/actions/notification.actions';
import { FinalForm } from 'src/app/models/final_form.model';
import { GLOBAL } from 'src/app/services/global';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, Validators } from '@angular/forms';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { RegistroComponent } from '../home/registro/registro.component';
import { rutClean } from 'rut-helpers';

interface AppState {
  form: Form;
}

declare const swal: any;

interface AppStateNotification {
  contador: Notification
}

interface AppStateFinalForm {
  formFinal: FinalForm
}
@Component({
  selector: 'main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.css'],
  providers: [SidenavService, ClaveUnicaService]

})
export class MainNavComponent implements OnInit {
  public materias = [];


  @ViewChild('drawer') sidenav: MatSidenav;
  @ViewChild('mailSave') mailSave: TemplateRef<any>;

  isExpanded = true;
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  form: Observable<Form>
  identity;
  token;
  tokenCU
  title;
  borradores = [];
  public activo;
  public notification_count;
  public contador_definitivo: Number
  public footer = GLOBAL.footer;
  public web = GLOBAL.web;
  public webUrl = GLOBAL.webUrl;
  public nombreMuni = GLOBAL.nombreMuni;

  public acotado = GLOBAL.acotado;
  public mail;

  public expandedItem;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  constructor(
    private _snackBar: MatSnackBar,
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog,
    private storeN: Store<AppStateNotification>,
    private _router: Router,
    private _userService: UserService,
    private store: Store<AppState>,
    private storeF: Store<AppStateFinalForm>,
    private _sidenavService: SidenavService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private claveUnicaService: ClaveUnicaService,
    private route: ActivatedRoute
  ) {

    this.matIconRegistry.addSvgIcon("obramenor", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/obramenor.svg'))
      .addSvgIcon("edificacion", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/edificacion.svg'))
      .addSvgIcon("subdivision", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/houses.svg'))
      .addSvgIcon("division", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/parquet.svg'))
      .addSvgIcon("copropiedad", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/profiles.svg'))
      .addSvgIcon("catastrofes", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/landslide.svg'))
      .addSvgIcon("antenas", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/antenna.svg'))
      .addSvgIcon("regularizacion", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/worker.svg'))
      .addSvgIcon("institucion", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/fire-station.svg'))


    this.form = this.store.select('form')
    this.storeN.select('contador').subscribe(
      response => {
        this.contador_definitivo = response.contador
      },
      error => {
        console.error(error)
      }
    )
    localStorage.clear();
    sessionStorage.removeItem("borrador")
    this.getFormularios();
    this.mail = this.fb.group({
      email: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]],
    })


  }
  regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  ngDoCheck() {
    this.expandedItem = sessionStorage.getItem("expandedItem")
  }

  ngOnInit() {

    if (sessionStorage.getItem('identity-domCloud')) {
      this.searchUser()

      this.identity = this._userService.getIdentity();
      this.token = this._userService.getToken();

      var rut = this.identity.rut + this.identity.dv

      this._userService.askForMail(rut).subscribe(
        response => {
          if (response.status == true) {
            this.dialog.open(this.mailSave, { disableClose: true });
            this.spinner.hide()

          } else {
            this.spinner.hide()
          }
        },
        error => {
          console.log(error)
          this.spinner.hide()
        }
      )
    } else {
      this._router.navigate(['/inicio'])
      swal({
        type: 'warning',
        text: "Para acceder a estos servicios, deberá iniciar sesión con su clave de sistema o su clave única.",
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false
      })

    }


    this._sidenavService.setSidenav(this.sidenav);




  }

  verBorradores() {
    const formOptions = this.dialog.open(BorradoresComponent, {

    });
  }
  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }

  getFormularios() {
    this._userService.getFormularios().subscribe(
      (response) => {


        this.materias = response.materias;
        console.log("response", response.materias)
      },
      error => {
        console.log("main-nav.component.ts error", error)
      });
  }

  getForm(id?, title?, online?) {


    if (online) {

      localStorage.clear();
      sessionStorage.removeItem('borrador');
      this.store.dispatch(new FormActions.FormUpdate(id, title))
      this.storeF.dispatch(new FinalFormactions.FinalFormCreate({
        newFormValues: {
          formulario: '1.1',
          tipo_solicitud: 'prueba',
        }
      }))

      setTimeout(() => {
        this.storeF.dispatch(new FinalFormactions.FinalFormCreate({
          newFormValues: {
            proyectos: []
          }
        }))
      }, 2000)
      if (this.acotado == true) {
        localStorage.setItem("form", '0.1')
        localStorage.setItem("formId", id)
        localStorage.setItem("formTitle", title)
      } else {
        localStorage.setItem("form", id)
      }
      setTimeout(() => {
        this.sidenav.toggle(false);
      }, 200)

      this._userService.formMostUsed(id, title).subscribe(
        response => {
          console.log(response)
        },
        error => {
          console.log('!!!!!!!!!!!!error formMostUsed', error)
        }
      )
    }
    else {
      alert("El formulario seleccionado solo se puede realizar presencialmente")
    }

  }
  saveDraft() {
    this.dialog.open(crearBorradorComponent)
  }
  back() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    localStorage.clear();
    sessionStorage.removeItem('borrador');
    this._router.navigate(['/inicio'])
  }

  async logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");

    const response = await this.claveUnicaService.logoutClaveUnica()
    console.log('Deslogeo exitoso:', response);

    this._snackBar.open("Se ha cerrado sesión", "Cerrar", {
      duration: 3000,
    });
    this.back()
  }

  inicio() {
    this._router.navigate(['/']);
  }

  getSolicitudes() {
    this.dialog.open(SolicitudesExpComponent);
  }

  getSolic() {
    //console.log("Entre en los forms")
    this.notification_count = 0;
    var contador = 0;
    this._userService.getSolicitudes().subscribe(
      response => {
        for (let index = 0; index < response.length; index++) {
          const element = response[index];
          if (element.fieldData.Estado == 3 && (element.fieldData.Notificado == "" || element.fieldData.Notificado == null)) {
            this.notification_count++;
          }
          if (contador == (response.length - 1)) {
            this.storeN.dispatch(new NotificationActions.NotificationUpdate(this.notification_count))
            if (contador > 0 && this.nombreMuni != 'Lo Barnechea') {
              this.toastr.warning('Pre-ingresos Rechazados', `Tienes ${this.notification_count} solicitude(s) de expediente rechazadas`);

            }
          }
          contador++;
        }

      },
      error => {
        console.log("main-nav.component.ts error", error)
      })
  }


  submitMail() {
    this.spinner.show()
    var rut = this.identity.rut + this.identity.dv

    console.log(this.mail.value.email)
    this._userService.saveNewMail(rut, this.mail.value.email).subscribe(
      response => {
        console.log(response)
        alert(response.message)
        this.dialog.closeAll()
        this.spinner.hide()
      },
      error => {
        console.log(error)
        this.spinner.hide()
      }
    )
  }

  searchUser() {
    /* Buscar si existe en fm */
    let identityData = this._userService.getIdentity();
    let rut = identityData.rut + identityData.dv
    this._userService.buscarUsuario(rutClean(rut)).subscribe(
      response => {
        if (response.message) {
          this.spinner.hide();
          console.log(response);

        }
        if (response.register) {
          this.spinner.hide();
          console.log(response);

          this.dialog.open(RegistroComponent, {
            id: "logindialog",
            width: '50vw', // Ajusta el ancho
            height: 'auto', // Ajusta la altura
            disableClose: true // Evita cerrar al hacer clic fuera (opcional)
          });

        }

      },
      error => {
        let e = JSON.parse(error._body);
        this.spinner.hide();
      }
    )
  }

}